import { onMounted, onUnmounted, onActivated, onDeactivated } from 'vue'

type fn = () => void

export function onOpened(start: fn, end: fn = () => {}) {
	let state = false
	onMounted(() => {
		if (!state) start()
		state = true
	})
	onActivated(() => {
		if (!state) start()
		state = true
	})
	onUnmounted(() => {
		if (state) end()
		state = false
	})

	onDeactivated(() => {
		if (state) end()
		state = false
	})
}
